

// src/components/HostsTable/HostsTable.jsx
import React, { useEffect } from "react"
import styled from "styled-components"
import { IconChapa } from "../../../../components/Icons"
import { useRestoUsers } from "../../../../hooks/useRestoUsers"
import ReactionButton from "../../../../components/ReactionButton"
import { useChat } from "../../../../hooks/useChat"
import { RankingList } from "../../../../components/RankingList"
import { useUser } from "../../../../hooks/useUser"

const TableWrapper = styled.div`
  width: 100%;
  background: #fff;
  border-radius: 8px;
  font-family: "Poppins", sans-serif;
`

const PointsContainer = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 6px;
`

const WrapName = styled.span`
  font-size: 0.9rem;
  color: #222;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 115px;
  width: 100%;
  display:block;
`;

export function RankingHostCEOTab() {
    const { ceoRestoHost, getHostCeoResto } = useRestoUsers();
    const { sendSingleMessage } = useChat();
    const { isCEO } = useUser()

    useEffect(() => {
        getHostCeoResto();
    }, [])


    const handleReaction = (data, userId) => {
        const { emoji, name } = data;
        sendSingleMessage(name, [userId], emoji)
    }

    const headers = [
        { key: "pos", label: "#", render: (a, i) => `${i + 1}` },
        { key: "avatar", label: "Almacenero", type: "avatar" },
        { key: "points", label: "Chapas", render: (row) => (<PointsContainer><IconChapa width="24" height="24" /><span>{row.points}</span></PointsContainer>) },
    ]

    const actions = [
        { render: (h, i) => <ReactionButton onReact={(data) => handleReaction(data, h._id)} /> }
    ]

    return (
        <>
            <TableWrapper>

                <RankingList
                    title={`Tus Almaceneros (${ceoRestoHost.length})`}
                    headers={headers}
                    data={ceoRestoHost}
                    actions={actions}
                    selectable={false}
                    loading={false}
                />
            </TableWrapper>
            <div style={{ height: 100 }}></div>
        </>
    )
}
